<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称"
                        prop="customerid">
            <el-select style="width: 100%;"
                       v-model="search.customerid"
                       filterable
                       remote
                       clearable
                       placeholder="请输入客户名称/编号搜索"
                       :remote-method="customerRemoteMethod"
                       :loading="selectLoading">
              <el-option v-for="item in customerItems"
                         :key="item.id"
                         :label="item.name + '/' + item.number"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="项目名称"
                        prop="customerid">
            <el-select style="width: 100%;"
                       v-model="search.projectid"
                       filterable
                       remote
                       clearable
                       placeholder="请输入客户名称/编号搜索"
                       :remote-method="projectRemoteMethod"
                       :loading="selectLoading">
              <el-option v-for="item in projectItems"
                         :key="item.id"
                         :label="item.name + '/' + item.number"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="批次名称"
                        prop="customerid">
            <el-select style="width: 100%;"
                       v-model="search.batchid"
                       filterable
                       remote
                       clearable
                       placeholder="请输入客户名称/编号搜索"
                       :remote-method="batchRemoteMethod"
                       :loading="selectLoading">
              <el-option v-for="item in batchItems"
                         :key="item.id"
                         :label="item.detail + '/' + item.number"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="resetSearch()">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <!--<el-button type="primary"-->
        <!--size="small"-->
        <!--icon="sj-icon-export"-->
        <!--@click="onExportPage()"></el-button>-->
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="任务名称"
                         min-width="90"></el-table-column>
        <el-table-column prop="batchid"
                         label="所属批次"
                         min-width="90">
          <template slot-scope="scope">
            {{scope.row.batch_name}}/{{scope.row.batchid}}
          </template>
        </el-table-column>
        <el-table-column prop="projectid"
                         label="所属项目"
                         min-width="90">
          <template slot-scope="scope">
            {{scope.row.project_name}}/{{scope.row.projectid}}
          </template>
        </el-table-column>
        <el-table-column prop="customerid"
                         label="所属客户"
                         min-width="90">
          <template slot-scope="scope">
            {{scope.row.customer_name}}/{{scope.row.customerid}}
          </template>
        </el-table-column>
        <el-table-column prop="budget"
                         label="项目预算"
                         min-width="90"></el-table-column>
        <el-table-column prop="ticket_predict"
                         label="开票预估"></el-table-column>
        <el-table-column prop="avg_salary"
                         label="平均价"></el-table-column>
        <el-table-column prop="predict_total"
                         label="预估费用">
        </el-table-column>
        <el-table-column prop="ticket_predict"
                         label="预估占比">
          <template slot-scope="scope">
            {{numberFormat(scope.row)}}%
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         :formatter="statusFormat"
                         label="状态">
        </el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         width="190"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新日期"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="{path:'/middle-end-task/update/' + scope.row.id, query: $route.query}">
                <el-button type="success"
                           size="mini"
                           v-if="scope.row.status === 0">编辑
                </el-button>
              </router-link>
              <el-button size="mini"
                         type="info"
                         @click="editStatus(scope.row.id, 1)" v-if="scope.row.status === 0">通过
              </el-button>

              <el-button type="danger"
                         size="mini"
                         @click="editStatus(scope.row.id, 2)" v-if="scope.row.status === 0">驳回
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'
import selectRemote from '@core/mixins/selectRemote'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  data () {
    return {
      search: {
        id: null,
        name: null,
      },
      customerItems: [],
      projectItems: [],
      batchItems: [],
      exportHeader: [
      ],
      selectLoading: false,
    }
  },
  computed: Vuex.mapState({
    ...Vuex.mapState({
      statusMap: state => state.middleEndTask.approveStatus,
    }),
  }),
  created () {},
  methods: {
    ...Vuex.mapActions(['getCustomerTable', 'getProjectTable', 'getCustomerDetail', 'getProjectDetail']),
    ...request.map(['getBatchTable', 'getBatchDetail']),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getMiddleEndApproveTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    dateFormat (row, column, cellValue, index) {
      return filter.formatDate(cellValue * 1000)
    },
    statusFormat (row, column, cellValue, index) {
      const statusMap = this.statusMap
      for (let i in statusMap) {
        if (statusMap.hasOwnProperty(i) && statusMap[i].value === cellValue * 1) {
          return statusMap[i].label
        }
      }
    },
    numberFormat (row) {
      if (row.ticket_predict > 0) {
        return _.round(row.predict_total / row.ticket_predict * 100, 2)
      } else {
        return 0
      }
    },
    editStatus (id, status) {
      let info
      if (status === 1) {
        info = '通过审批'
      } else if (status === 2) {
        info = '驳回审批'
      }
      this.$confirm('确认' + info + '，是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('editMiddleEndApproveStatus', {id: id, status: status}).then(() => {
          if (status === 1) {
            this.$message.success('创建中台任务成功，请在批量任务列表中查看进度')
          } else {
            this.$message.success('操作成功')
          }
          this.onRefresh()
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    customerRemoteMethod (query) {
      console.log(query)
      this.selectRemoteMethod(query, this.getCustomerTable, ({data}) => {
        this.customerItems = data
      })
    },
    projectRemoteMethod (query) {
      this.selectRemoteMethod(query, this.getProjectTable, ({data}) => {
        this.projectItems = data
      })
    },
    batchRemoteMethod (query) {
      this.selectRemoteMethod(query, this.getBatchTable, ({data}) => {
        this.batchItems = data
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/middle-end-task/pages/MiddleEndTaskAudit.vue